import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { COMMON_MESSAGES } from 'appRootPath/messages';
import { CpDocumentsHelperService } from 'appRootPath/services/documents-helper.service';
import { DOCUMENT_NAME_MAP } from 'appRootPath/shared/global-meta-data';

@Component({
  selector: 'app-upload-signed-docs-confirm',
  templateUrl: './upload-signed-docs-confirm.component.html',
  styleUrls: ['./upload-signed-docs-confirm.component.scss']
})
export class UploadSignedDocsConfirmComponent implements OnInit {

  @Input() uploadSignData = null;
  @Input() modalTitle = '';
  @Input() modalConfirmMsg = '';

  docsWithSignatories = [];
  base64Pdf: string;
  pdfUrl: SafeResourceUrl | null = null;
  docUploadTitle: string;
  docUploadId: string;

  uploadedDocs = [];
  modalDisplayTitle = '';
  modalDisplayConfirmMsg = '';
  documentNamesMap = DOCUMENT_NAME_MAP;
  signatoryConfirmMessage = COMMON_MESSAGES.SIGNATORY_CONFIRMATION;
  uploadConfirmMessage = COMMON_MESSAGES.UPLOAD_DOCS_CONFIRMATION;
  signatoryUploadConfirmMessage = COMMON_MESSAGES.SIGNATORY_UPLOAD_DOCS_CONFIRMATION;

  constructor(
    public activeModal: NgbActiveModal,
    private readonly DocHelperService: CpDocumentsHelperService,
    private readonly sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    let customTitle = '';
    let customConfirmMsg = '';
    this.uploadSignData.forEach(doc => {
      if (doc.selectedSignatories?.length && !doc.uploadedSignedDoc) {
        this.docsWithSignatories.push(doc);
      } else if (!doc.selectedSignatories?.length && doc.uploadedSignedDoc) {
        this.uploadedDocs.push(doc);
      }
    });

    if (this.docsWithSignatories.length > 0 && this.uploadedDocs.length > 0) {
      customTitle = 'Confirm Signatories and Signed Doc Upload';
      customConfirmMsg = COMMON_MESSAGES.SIGNATORY_UPLOAD_DOCS_CONFIRMATION;
    } else if (this.docsWithSignatories.length > 0) {
      customTitle = 'Confirm Signatories';
      customConfirmMsg = COMMON_MESSAGES.SIGNATORY_CONFIRMATION;
    } else if (this.uploadedDocs.length > 0) {
      customTitle = 'Confirm Signed Doc Upload';
      customConfirmMsg = COMMON_MESSAGES.UPLOAD_DOCS_CONFIRMATION;
    }

    this.modalDisplayTitle = this.modalTitle || customTitle;
    this.modalDisplayConfirmMsg = this.modalConfirmMsg || customConfirmMsg;
  }

  capitalizeWords(string: string) {
    return string.replace(/\b\w/g, char => char.toUpperCase());
  }

  showDocInModal(docUpload) {
    if (docUpload.uploadedSignedDoc.includes('base64')) {
      this.docUploadTitle = this.capitalizeWords(docUpload.document_name.replace(/_/g, ' '));
      this.docUploadId = docUpload.document_name;
      this.base64Pdf = docUpload.uploadedSignedDoc;
      this.openModal();
    } else {
      this.DocHelperService.showDocsInModal(docUpload.document_name, docUpload.uploadedSignedDoc);
    }
  }

  convertBase64ToBlob(base64Data: string, contentType: string): Blob {
    const byteCharacters = atob(base64Data.split(',')[1]);
    const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
    return new Blob([new Uint8Array(byteNumbers)], { type: contentType });
  }

  openModal() {
    const blob = this.convertBase64ToBlob(this.base64Pdf, 'application/pdf');
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));

    const modalElement = document.getElementById('pdfModal');
    if (modalElement) {
      const modal = new (window as any).bootstrap.Modal(modalElement);
      modal.show();
    }

    this.setPageAccessibility(false);
  }

  closePDFModal() {
    const modalElement = document.getElementById('pdfModal');
    if (modalElement) {
      const modalInstance = (window as any).bootstrap.Modal.getInstance(modalElement);
      modalInstance?.hide();
    }

    this.setPageAccessibility(true);
  }

  closeModal(confirm: boolean) {
    this.activeModal.close(confirm);
    this.setPageAccessibility(true);

    setTimeout(() => {
      const focusElement = document.getElementById('confirm-send-for-signing');
      focusElement?.focus();
    }, 100);
  }

  setPageAccessibility(enable: boolean) {
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      if (enable) {
        appRoot.removeAttribute('aria-hidden');
        appRoot.removeAttribute('inert');
      } else {
        appRoot.setAttribute('aria-hidden', 'true');
        appRoot.setAttribute('inert', 'true');
      }
    }
  }
}
